import styled from 'styled-components';
import { theme } from '@frameio/vapor';

const { eases, durations } = theme.transitions;

export const Border = styled.div`
  border: solid 1px ${theme.colors.border.primary};
  border-radius: ${theme.spaces[6]};
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  transition: all ${durations[100]} ${eases.primary};
  width: 100%;
`;
